"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControl = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  withRef: _propTypes.object
} : {};
const defaultProps = {
  component: 'div'
};

const FormControl = ({
  withRef,
  component,
  className,
  ...other
}) => {
  return (0, _core.jsx)(_components.FormControl, (0, _extends2.default)({
    as: component,
    ref: withRef,
    className: className
  }, other));
};

process.env.NODE_ENV !== "production" ? FormControl.propTypes = propTypes : void 0;
FormControl.defaultProps = defaultProps;
const WithForwardRef = (0, _utils.withForwardRef)(FormControl);
exports.FormControl = WithForwardRef;